export const ALL_ITEM_COIN = [
  {
    categry: "coin",
    itemList: [
      {
        itemSelected: "aubrey",
        itemName: "Aubrey",
        itemDescription:
          "Aubrey is a coin packaging which made from high-quality materials and is designed to last and protect your coins from damage.",
        itemDescriptionList: [
          "Made in Thailand Craftsmanship",
          "Variety of World Class Materials",
          "Professional Consultation",
          "Fast Delivery",
        ],
        itemDesktopBig: [
          "/images/listItem/customizedProjects/Coin/Desktop/Aubrey/700x700px/lussopack-coinbox-aubrey-01.webp",
          "/images/listItem/customizedProjects/Coin/Desktop/Aubrey/700x700px/lussopack-coinbox-aubrey-02.webp",
          "/images/listItem/customizedProjects/Coin/Desktop/Aubrey/700x700px/lussopack-coinbox-aubrey-03.webp",
          "/images/listItem/customizedProjects/Coin/Desktop/Aubrey/700x700px/lussopack-coinbox-aubrey-04.webp",
        ],
        itemDesktopSmall: [
          "/images/listItem/customizedProjects/Coin/Desktop/Aubrey/130x130px/lussopack-coinbox-aubrey-01.webp",
          "/images/listItem/customizedProjects/Coin/Desktop/Aubrey/130x130px/lussopack-coinbox-aubrey-02.webp",
          "/images/listItem/customizedProjects/Coin/Desktop/Aubrey/130x130px/lussopack-coinbox-aubrey-03.webp",
          "/images/listItem/customizedProjects/Coin/Desktop/Aubrey/130x130px/lussopack-coinbox-aubrey-04.webp",
        ],
        itemMobileBig: [
          "/images/listItem/customizedProjects/Coin/Mobile/Aubrey/335x335px/lussopack-coinbox-aubrey-01.webp",
          "/images/listItem/customizedProjects/Coin/Mobile/Aubrey/335x335px/lussopack-coinbox-aubrey-02.webp",
          "/images/listItem/customizedProjects/Coin/Mobile/Aubrey/335x335px/lussopack-coinbox-aubrey-03.webp",
          "/images/listItem/customizedProjects/Coin/Mobile/Aubrey/335x335px/lussopack-coinbox-aubrey-04.webp",
        ],
        itemMobileSmall: [
          "/images/listItem/customizedProjects/Coin/Mobile/Aubrey/100x100px/lussopack-coinbox-aubrey-01.webp",
          "/images/listItem/customizedProjects/Coin/Mobile/Aubrey/100x100px/lussopack-coinbox-aubrey-02.webp",
          "/images/listItem/customizedProjects/Coin/Mobile/Aubrey/100x100px/lussopack-coinbox-aubrey-03.webp",
          "/images/listItem/customizedProjects/Coin/Mobile/Aubrey/100x100px/lussopack-coinbox-aubrey-04.webp",
        ],
      },
      {
        itemSelected: "jacopo",
        itemName: "Jacopo",
        itemDescription:
          "Jacopo is a coin packaging made from high-quality materials and is designed to last and protect your coins from damage.",
        itemDescriptionList: [
          "Made in Thailand Craftsmanship",
          "Variety of World Class Materials",
          "Professional Consultation",
          "Fast Delivery",
        ],
        itemDesktopBig: [
          "/images/listItem/customizedProjects/Coin/Desktop/Jacopo/700x700px/lussopack-coinbox-jacopo-01.webp",
          "/images/listItem/customizedProjects/Coin/Desktop/Jacopo/700x700px/lussopack-coinbox-jacopo-02.webp",
        ],
        itemDesktopSmall: [
          "/images/listItem/customizedProjects/Coin/Desktop/Jacopo/130x130px/lussopack-coinbox-jacopo-01.webp",
          "/images/listItem/customizedProjects/Coin/Desktop/Jacopo/130x130px/lussopack-coinbox-jacopo-02.webp",
        ],
        itemMobileBig: [
          "/images/listItem/customizedProjects/Coin/Mobile/Jacopo/335x335px/lussopack-coinbox-jacopo-01.webp",
          "/images/listItem/customizedProjects/Coin/Mobile/Jacopo/335x335px/lussopack-coinbox-jacopo-02.webp",
        ],
        itemMobileSmall: [
          "/images/listItem/customizedProjects/Coin/Mobile/Jacopo/100x100px/lussopack-coinbox-jacopo-01.webp",
          "/images/listItem/customizedProjects/Coin/Mobile/Jacopo/100x100px/lussopack-coinbox-jacopo-02.webp",
        ],
      },
      {
        itemSelected: "viola",
        itemName: "Viola",
        itemDescription:
          "Viola is a coin packaging, designed to protect your coins from damage, made from high-quality materials and is designed to last.",
        itemDescriptionList: [
          "Made in Thailand Craftsmanship",
          "Variety of World Class Materials",
          "Professional Consultation",
          "Fast Delivery",
        ],
        itemDesktopBig: [
          "/images/listItem/customizedProjects/Coin/Desktop/Viola/700x700px/lussopack-coinbox-viola-01.webp",
          "/images/listItem/customizedProjects/Coin/Desktop/Viola/700x700px/lussopack-coinbox-viola-02.webp",
        ],
        itemDesktopSmall: [
          "/images/listItem/customizedProjects/Coin/Desktop/Viola/130x130px/lussopack-coinbox-viola-01.webp",
          "/images/listItem/customizedProjects/Coin/Desktop/Viola/130x130px/lussopack-coinbox-viola-02.webp",
        ],
        itemMobileBig: [
          "/images/listItem/customizedProjects/Coin/Mobile/Viola/335x335px/lussopack-coinbox-viola-01.webp",
          "/images/listItem/customizedProjects/Coin/Mobile/Viola/335x335px/lussopack-coinbox-viola-02.webp",
        ],
        itemMobileSmall: [
          "/images/listItem/customizedProjects/Coin/Mobile/Viola/100x100px/lussopack-coinbox-viola-01.webp",
          "/images/listItem/customizedProjects/Coin/Mobile/Viola/100x100px/lussopack-coinbox-viola-02.webp",
        ],
      },
    ],
  },
];
